<template>
  <div class="warm-prompt PayWarmPrompt">
    温馨提示： 网站设置防盗刷系统，请合理使用海量下载账号。如用户短时间内高频或大量下载可能触发该系统，将暂时暂停账号下载功能，如有疑问
    <a
      :href="PAGE_LINK.SERVICE"
      target="_blank"
      class="icon-kefu-box">
      <i class="iconfont icon-kefu"/>在线客服
    </a>
  </div>
</template>

<script>
import { PAGE_LINK } from '@/constant/PAGE_PATH'
export default {
  name: "PayWarmPrompt",
  data(){
    return{
      PAGE_LINK
    }
  }
}
</script>

<style lang="scss" scoped>
/* 温馨提示 */
.warm-prompt {
  font-size: 14px;
  color: #596088;
  line-height: 19px;
  text-align: center;
  //margin-top: 24px;
  padding: 28px 0 45px;

  .icon-kefu-box {
    margin-left: 8px;
    width: 96px;
    height: 28px;
    border-radius: 19px;
    border: 1px solid #596088;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #596088;

    @include ElementHover($color-primary, '') {
      border-color: $color-primary;
    }
  ;

    i {
      font-size: 18px;
      margin-right: 5px;

    }
  }
}
</style>
